export default "__VITE_ASSET__ClpqP7oP__"